import { Card, DonutPopulated } from '@/components/shared';
import { useService } from '@/hooks';
import { Section } from '@/layout';
import { useFilterContext } from '@/pages/Lgbt/contexts/FilterContext';
import { useJobIncome } from '@/services/lgbt/jobIncome';
import { Data } from 'big-data';
import { useEffect, useMemo } from 'react';

const colorNameMap = new Map([
  ['Ficaram desempregadas', '#D4282A'],
  ['Tiveram acesso ao Auxílio Emergencial', '#55A546'],
  ['Tiveram a renda mensal reduzida', '#FFB02E'],
  ['Não sofreram impacto na vida financeira', '#979797']
]);

function resolveColor(name: string) {
  return colorNameMap.get(name) || '#1D696F';
}

export function JobLifeCovid() {
  const { ibge, orientation, city, identity } = useFilterContext();

  const { data, loading, error, request } = useService<Data>();

  useEffect(() => {
    request(() =>
      useJobIncome.jobLifeCovid({ ibge, orientation, genderIdentity: identity })
    );
  }, [request, ibge, orientation, identity]);

  const formatedDataDonut = useMemo(() => {
    return data.map((d) => {
      const color = resolveColor(d.name);

      return {
        ...d,
        color
      };
    });
  }, [data]);

  return (
    <Section>
      <Card
        title="Vida financeira pós pandemia de COVID-19 das pessoas LGBTQIA+ entrevistadas"
        loading={loading}
        error={error}
        empty={data.length === 0}
        tags={[
          city ?? 'Ceará',
          orientation ?? 'Todas as orientações sexuais',
          identity ?? 'Todas as identidades de gênero'
        ]}
      >
        <DonutPopulated
          calculatedOut
          hiddenValue
          labelOnDonut
          donutHeight={300}
          data={formatedDataDonut}
          thickness={40}
          flexDirection="column"
          percentage
        />
      </Card>
    </Section>
  );
}
